import { graphql } from 'relay-runtime';

export const getTeachersTableFiltersInfo = graphql`
  query TeachersDataTableFiltersQuery {
    classes(first: 100) {
      nodes {
        id
        name
        section
      }
    }
    allRoles {
      nodes {
        id
        name
      }
    }
  }
`;
